// Icon and tag colour per assessment template type, shared by the templates list and the template page (US 9398)
export const TEMPLATE_TYPE_ICONS = { control: 'globe', risk: 'crosshairs', bia: 'wave-square' };
export const TEMPLATE_TYPE_TAGS = { control: 'v2-tag--teal', risk: 'v2-tag--blue', bia: 'v2-tag--violet' };
